import { createListStoreWithQuery } from '@/store/list-state.factory';

export const useApiKeysListStore = createListStoreWithQuery('api-keys-list-state');
